<template>
  <v-layout class="rounded rounded-md">
    <v-navigation-drawer
      :width="layoutDrawerWidth"
      color="#37474F"
      permanent
      class="admin-drawer"
      :class="{ 'admin-drawer--expanded': drawerExpanded }"
      @mouseenter="drawerHover = true"
      @mouseleave="drawerHover = false">
      <div class="admin-drawer-content" :class="{ 'admin-drawer-content--expanded': drawerExpanded }">
        <div class="d-flex justify-center px-4 py-10">
          <NuxtLink :to="localePath('/')" class="web-logo">
            <img src="~/assets/images/ug-logo.png" alt="UG logo" class="logo">
          </NuxtLink>
        </div>
        <v-list v-model:opened="openGroup" class="admin-nav-list">

          <v-list-group :value="title" v-for="({ title, icon, items }) in visibleAdminMenu" :key="title">
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                :prepend-icon="icon"
                :title="title"
                base-color="#fff"
                variant="plain"></v-list-item>
            </template>

            <template v-for="(report, i) in items">
              <v-divider v-if="isMenuDivider(report)"></v-divider>
              <v-list-item v-else :key="i" :title="report.title" :value="report.routerName" :to="localePath({ name: report.routerName })" base-color="#fff" variant="text"></v-list-item>
            </template>

          </v-list-group>
        </v-list>

        <v-list class="admin-action-list">
          <v-list-item prepend-icon="home" title="UG首頁" :to="localePath('/')" base-color="#fff" variant="plain"></v-list-item>
          <v-list-item prepend-icon="logout" title="登出" base-color="#fff" variant="plain" @click="useLogout"></v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-main class="admin-main" :class="{ 'admin-main--shifted': drawerOverlayOpen }" style="min-height: 100vh;">
      <slot />
      <div v-show="drawerOverlayOpen" class="admin-content-overlay"></div>
    </v-main>
  </v-layout>
</template>

<script lang="ts" setup>
import { AdminMenu, isMenuDivider, filterMenuByPrivilege } from '@/lib/menu'

const localePath = useLocalePath()
const route = useRoute()

const openGroup = ref(['帳戶資料管理', '月報管理'])
const visibleAdminMenu = computed(() => filterMenuByPrivilege(AdminMenu))
const drawerHover = ref(false)
const isAdminHome = computed(() => route.path.replace(/^\/(zh|en)/, '').replace(/\/$/, '') === '/admin')
const drawerExpanded = computed(() => isAdminHome.value || drawerHover.value)
const drawerOverlayOpen = computed(() => !isAdminHome.value && drawerHover.value)
const layoutDrawerWidth = computed(() => isAdminHome.value ? 200 : 12)

</script>

<style lang="stylus" scoped>
.web-logo
  width 30px
  img.logo
    width 100%
.admin-drawer
  overflow visible
  transition none
  :deep(.v-navigation-drawer__content)
    overflow visible
  &--expanded
    box-shadow 6px 0 18px rgba(0,0,0,.18)
.admin-drawer-content
  display flex
  flex-direction column
  width 200px
  min-height 100vh
  background #37474F
  transform translateX(-188px)
  transition transform .32s ease
  &--expanded
    transform translateX(0)
.admin-nav-list
  flex 1
  :deep(.v-list-group)
    .v-list-item__prepend
      width 40px
    .v-list-item__append
      width 24px
    .v-list-item__append > .v-icon
      margin-inline-start 0
    .v-list-item-title
      font-size 16px
    .v-list-group__items .v-list-item
      padding-inline-start 56px!important
.admin-action-list
  border-top 1px solid rgba(255,255,255,.12)
.admin-main
  position relative
  transition transform .32s ease
  will-change transform
.admin-main--shifted
  transform translateX(188px)
.admin-content-overlay
  position fixed
  inset 0
  width 100vw
  height 100dvh
  min-height 100vh
  z-index 2147483647
  pointer-events none
  background rgba(0,0,0,.36)
  animation admin-overlay-in .32s ease
@keyframes admin-overlay-in
  from
    opacity 0
  to
    opacity 1
</style>
